export default __webpack_public_path__ + "static/media/erato.86220b7a.jpg";